<mic-spinner-overlay ariaLabel="loading" color="primary" [loading]="isLoadingData || isSavingData">

<!-- Page title -->
<h1>{{ 'stock.title' | translate }}</h1>
<p id="description">{{ 'stock.description' | translate }}</p>

<!-- Page content-->
<mat-card class="card-content">
  <mat-card-content>

    <!-- Main buttons for actions on modifications -->
    <tkc-modification-buttons
      [isModificationsPending]="isModificationsPending"
      [saveModifications]="saveModifications.bind(this)"
      [resetModifications]="resetModifications.bind(this)"
    />

    <!-- Filters -->
    <div id="filters" class="card-side-padding">

      <app-autocomplete
        [placeholder]="'stock.filter1.placeholder' | translate"
        [label]="'stock.filter1.label' | translate"
        [filterCtrl]="filterCtrl"
        [filteredList$]="filteredList$"
        [displayKey]="'specification'"
        (reset)="resetTireSpecFilter()"
        (elementSelected)="onItemSelected($event)"
      />

      <mat-form-field appearance="outline">
        <mat-label>{{ 'stock.filter2.label' | translate }}</mat-label>
        <mat-select [placeholder]="'stock.filter2.placeholder' | translate" [formControl]="manufacturer" multiple>
          <mat-select-trigger>
            <ng-container *ngIf="!manufacturer.value?.length">
              {{ 'stock.filter2.placeholder' | translate }}
            </ng-container>
            <ng-container *ngIf="manufacturer.value?.length">
              @if (manufacturer.value.length == 1) {
                {{ 'stock.singularSelected' | translate }}
              } @else {
                {{ 'stock.pluralSelected' | translate:{count: manufacturer.value.length} }}
              }
            </ng-container>
          </mat-select-trigger>

          <mat-option *ngFor="let manufacturer of manufacturerFilteredList" [value]="manufacturer">
            {{ manufacturer }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="manufacturer-selected" *ngIf="manufacturer.value?.length">
        @if (manufacturer.value.length == 1) {
          <div class="manufacturer-title">{{ 'stock.singularSelectedManufacturer' | translate }}</div>
        } @else {
          <div class="manufacturer-title">{{ 'stock.pluralSelectedManufacturers' | translate }}</div>
        }
        <div class="manufacturer-list" (click)="$event.stopPropagation()">
          <span class="manufacturer-item" *ngFor="let m of manufacturer.value">
            <button type="button" class="remove-btn" aria-label="remove" (click)="removeManufacturer(m); $event.stopPropagation()">
              <span class="manufacturer-name">{{ m }}</span>
              &times;
            </button>
          </span>
        </div>
      </div>

    </div>

    <!-- Tab selector -->
    <div id="tab-selector" class="card-side-padding">
      <div class="buttons-left">
        <div class="button-wrapper" [ngClass]="selectedTable === TABLE_STOCK_NAME ? 'selected-button' : ''">
          <button id="inventory" mat-flat-button color="primary"
                  class="mic-btn-icon-left"
                  (click)="switchTable(TABLE_STOCK_NAME)"
                  [ngClass]="selectedTable === TABLE_STOCK_NAME ? 'active-button' : 'normal-button'">
            <mat-icon class="size-icon">inventory_2</mat-icon>
            <span>{{ 'stock.firstTab' | translate }}</span>
          </button>
        </div>
        <div class="button-wrapper" [ngClass]="selectedTable === TABLE_ARRIVAL_NAME ? 'selected-button' : ''">
          <button id="arrivals" mat-flat-button color="primary"
                  class="mic-btn-icon-left"
                  (click)="switchTable(TABLE_ARRIVAL_NAME)"
                  [ngClass]="selectedTable === TABLE_ARRIVAL_NAME ? 'active-button' : 'normal-button'">
            <mat-icon class="size-icon">orders</mat-icon>
            <span>{{ 'stock.secondTab' | translate }}</span>
          </button>
        </div>
      </div>
      @if(selectedTable === TABLE_ARRIVAL_NAME) {
        <div class="import-arrivals">
          <button mat-flat-button class="mic-btn-icon-left" (click)="openImportArrivalsModal()">
            <mat-icon class="size-icon">file_upload</mat-icon>
            <span>{{ 'stock.importArrivals.button' | translate }}</span>
          </button>
        </div>
      }
    </div>

    <!-- Tab content-->
    @if (selectedTable === TABLE_STOCK_NAME) {
      <mic-stock-inventory-table [(startYear)]="startYearInventory"
                                 [(startMonth)]="startMonthInventory"
                                 [tireSpecFilteredId]="tireSpecFilteredId$.value"
                                 [manufacturerFiltered]="manufacturerSelectedList$.value"
                                 [(isModificationsPending)]="isModificationsPending"
                                 [(isLoadingData)]="isLoadingData"
                                 [(isSavingData)]="isSavingData"
                                 (dataLoaded)="onTableDataLoaded()" />
    } @else if (selectedTable === TABLE_ARRIVAL_NAME) {
      <mic-stock-arrivals-table [(startYear)]="startYearArrivals"
                                [(startMonth)]="startMonthArrivals"
                                [tireSpecFilteredId]="tireSpecFilteredId$.value"
                                [manufacturerFiltered]="manufacturerSelectedList$.value"
                                [(isModificationsPending)]="isModificationsPending"
                                [(isLoadingData)]="isLoadingData"
                                [(isSavingData)]="isSavingData"
                                (dataLoaded)="onTableDataLoaded()"/>
    }
  </mat-card-content>
</mat-card>

</mic-spinner-overlay>
